import {
    EventCardImage,
    EventCardLink,
    EventCardLinkProps,
    EventImageProps,
    hasCarouselWidget,
} from '@eventbrite/event-renderer';
import React from 'react';
import { EventCardCarousel, EventCardCarouselProps } from './components';

export type EventCardMultiImageProps = EventCardCarouselProps & {
    isLazyImage?: EventImageProps['loading'];
    linkProps: EventCardLinkProps;
    hasMultiImageEnabled?: boolean;
};

const autoplayOptions = {
    delay: 3500,
    stopOnMouseEnter: true,
};

export function EventCardMultiImage({
    event,
    isLazyImage,
    linkProps,
    hasMultiImageEnabled,
    ...props
}: EventCardMultiImageProps) {
    if (hasMultiImageEnabled && hasCarouselWidget(event)) {
        return (
            <EventCardCarousel
                event={event}
                isLazyImage={isLazyImage}
                linkProps={linkProps}
                data-testid="event-card-carousel"
                autoplayOptions={autoplayOptions}
                {...props}
            />
        );
    } else {
        return (
            <EventCardLink {...linkProps}>
                <EventCardImage
                    name={event.name}
                    loading={isLazyImage}
                    src={event.imageUrl}
                    {...props}
                />
            </EventCardLink>
        );
    }
}
